import React, { ReactNode } from 'react';

import { Box, HStack, Icon } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import Link, { IInLineLinkProps, ILinkProps } from 'components/link';
import { NewBadgeIcon } from 'pages/account/icons/new-badge-icon';
import { CustomEventNames } from 'state/amplitude';
import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

const StyledLink = Link.withConfig({
  borderBottomWidth: '1px',
  borderStyle: 'solid',
  borderBottomColor: `${primitive.$greyFour}`,
  width: '100%',
  color: primitive.$greyOne,
  paddingX: '0',
  paddingY: '5',
  _web: {
    cursor: 'pointer',
  },
});

const BadgeContainer = HStack.withConfig({
  width: '$14',
  marginLeft: '$1',
  padding: '$1',
  paddingRight: '$2',
  alignContent: 'center',
  backgroundColor: '#D1FAE5',
  borderRadius: 5,
});

interface AccountLinkProps {
  link: string;
  label: string;
  testID?: string;
  showNewBadge?: boolean;
  leftIcon: ReactNode;
  linkProps?: IInLineLinkProps | ILinkProps;
}

export const AccountLink = ({
  link,
  label,
  leftIcon,
  linkProps,
  testID,
  showNewBadge,
}: AccountLinkProps) => {
  const Badge = () => (
    <BadgeContainer>
      <Box width={'$4'} alignSelf={'center'}>
        <NewBadgeIcon />
      </Box>
      <Typography fontSize="sm">{t('new')}</Typography>
    </BadgeContainer>
  );

  return (
    <StyledLink
      to={link}
      eventName={CustomEventNames.BUTTON_CLICK_ACCOUNT_INFO}
      testID={testID}
      color={primitive.$bbqBrown}
      justifyContent="space-between"
      {...linkProps}
    >
      <HStack alignItems={'center'}>
        <Box>{leftIcon}</Box>
        <Typography ml="$3" style={{ alignContent: 'center' }}>
          {label}
        </Typography>
        <Box>{showNewBadge && <Badge />}</Box>
      </HStack>
      <Icon variant="next" ml="$1" width="4" {...hiddenAccessibilityPlatformProps} />
    </StyledLink>
  );
};
